import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import Modal from 'src/components/common/Modal'
import { COLORS } from 'src/utils/Themes/colors'
import ChangePassword from 'src/components/Individual/profile/ChangePassword'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import ChangeMobileNumber from 'src/components/Individual/profile/ChangeMobileNumber'
import LoadingModal from 'src/components/common/LoadingModal'
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded'
import { useHistory } from 'react-router-dom'
import { CLIENT_TYPE } from 'src/utils/constants/common'
import { getFullName } from 'src/utils/commonMethods'
import NotificationSettings from 'src/components/Individual/profile/NotificationSettings'
import DocumentsUpload from 'src/components/Individual/profile/DocumentsUpload'

const Profile = () => {
  const classes = useStyles()
  const history = useHistory()
  const userInfo = useSelector((state) => state?.userInfo)
  const [openModal, setOpenModal] = useState(false)

  const [isEditing, setEditing] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleEditClick = () => {
    setEditing(true)
  }

  const getClientFullName = (userData) => {
    if (userData?.policyHolderType === CLIENT_TYPE?.CORPORATE) {
      return userData?.companyName
    }
    return getFullName([userData?.firstName, userData?.lastName])
  }

  const toggleChangePasswordModal = (toggle) => {
    setOpenModal(toggle)
  }

  const handleGoBack = () => {
    setLoading(true)
    history.goBack()
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  return (
    <>
      <LoadingModal loading={loading} />
      {openModal ? (
        <Modal
          id='passwordModal'
          bgcolor={'#EEEEEE'}
          ordered={openModal}
          width={'60%'}
          left={'20%'}
          top={'14%'}
          modelClosed={() => toggleChangePasswordModal(false)}
        >
          <ChangePassword closeModal={() => toggleChangePasswordModal(false)} />
        </Modal>
      ) : null}
      {isEditing ? (
        <Modal
          id='phoneNumberModal'
          bgcolor={'#EEEEEE'}
          ordered={isEditing}
          width={'60%'}
          left={'20%'}
          top={'14%'}
          className={classes.modelStyles}
          modelClosed={() => toggleChangePasswordModal(false)}
        >
          <ChangeMobileNumber
            closeModal={() => toggleChangePasswordModal(false)}
            currentMobileNo={userInfo?.userInfo?.userData?.mobileNumber}
            setEditing={setEditing}
            setLoading={setLoading}
          />
        </Modal>
      ) : null}
      <div className={classes.mainContainer}>
        <div className={classes.headingContainer}>
          <div className={classes.heading}>
            <IconButton onClick={handleGoBack}>
              <KeyboardBackspaceRoundedIcon />
            </IconButton>
            <span>My Profile Details</span>
          </div>
          <hr className={classes.separator} />
        </div>
        <div className={classes.contentContainer}>
          <div className={classes.detailsContainer}>
            <div className={classes.detailsRow}>
              <span className={classes.detailLabel}>Username</span>
              <span>:</span>
              <span className={classes.detailSpan} data-test={'user-name'}>
                {userInfo?.userInfo?.userData?.userName}
              </span>
            </div>
            <div className={classes.detailsRow}>
              <span className={classes.detailLabel}>Full Name</span>
              <span>:</span>
              <span className={classes.detailSpan} data-test={'full-name'}>
                {getClientFullName(userInfo?.userInfo?.userData)}
              </span>
            </div>
            <div className={classes.detailsRow}>
              <span className={classes.detailLabel}>Email</span>
              <span>:</span>
              <span className={classes.detailSpan} data-test={'email'}>
                {userInfo?.userInfo?.userData?.emailId ?? '---'}
              </span>
            </div>
            <div className={classes.detailsRow}>
              <span className={classes.detailLabel}>Mobile Number</span>
              <span>:</span>
              <span className={classes.detailSpan} data-test={'mobile-number'}>
                {userInfo?.userInfo?.userData?.mobileNumber ?? '---'}
                <IconButton
                  onClick={handleEditClick}
                  className={classes.handleEditIconContainer}
                >
                  <EditIcon className={classes.editIcon} />
                </IconButton>
              </span>
            </div>
          </div>
          {/* <div className={classes.actionsContainer}>
            <Button
              className={classes.changePasswordButton}
              onClick={() => toggleChangePasswordModal(true)}
              data-test={'change-password-button'}
              id='changePasswordButton'
            >
              CHANGE PASSWORD
            </Button>
          </div> future development might be there */}
        </div>

        <hr className={classes.separator} />
        <NotificationSettings />
        <hr className={classes.separator} />
        <DocumentsUpload />
      </div>
    </>
  )
}

export default Profile

const useStyles = makeStyles({
  mainContainer: {
    margin: '10px',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '5px',
  },
  headingContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
  },
  editIcon: {
    padding: '0px !important',
    alignItems: 'center',
    borderRadius: '10px',
    width: '20px',
    color: '#B92250',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '18px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  handleEditIconContainer: {
    padding: '0px !important',
    alignItems: 'center',
    borderRadius: '10px',
    paddingX: '10px!important',
    paddingY: '0px !important',
  },
  modelStyles: {
    bgcolor: 'black',
    padding: '10px',
    alignItems: 'center',
    borderRadius: '10px',
  },
  contentContainer: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    padding: '10px 0',
  },
  actionsContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
    marginTop: '15px',
  },
  detailsContainer: {
    height: '100% !important',
    width: '50% !important',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  detailsRow: {
    height: '100% !important',
    width: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  detailSpan: {
    width: '100% !important',
    alignItems: 'center',
  },
  detailLabel: {
    fontWeight: 'bold',
    width: '100% !important',
    fontSize: '14px',
  },
  changePasswordButton: {
    textTransform: 'unset !important',
    fontSize: '11px !important',
    fontWeight: '600 !important',
    background: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    color: `${COLORS.WHITE} !important`,
    height: '24px !important',
    padding: '17px 15px !important',
    borderRadius: '7px !important',
    '&:hover': {
      backgroundColor: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    },
  },
  separator: {
    margin: 0,
  },
})
